<template>
  <div class="">
    <div class="modal is-active" v-if="course">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <b>Bokning</b>
          </p>
        </header>
        <section class="modal-card-body" v-if="step == 1">
          <h3 class="title is-4">Kunduppgifter</h3>

          <p>
            För att boka kursen vänligen fyll i dina personuppgifter.
            Betalningen sker i nästa steg.
          </p>
          <br />
          <form>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Namn *</label>
                  <div class="control has-icons-left">
                    <input
                      name="given-name"
                      class="input"
                      type="text"
                      v-model="customer.first_name"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">Efternamn *</label>
                  <div class="control">
                    <input
                      name="family-name"
                      class="input"
                      type="text"
                      v-model="customer.last_name"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="field" v-if="extendedFields">
              <label class="label">Personnummer *</label>
              <div class="control">
                <input
                  name="tel"
                  class="input"
                  type="text"
                  v-model="customer.ssi"
                />
              </div>
            </div>

            <div class="field">
              <label class="label">Adress *</label>
              <div class="control has-icons-left">
                <input
                  name="street-address"
                  class="input"
                  type="text"
                  v-model="customer.thoroughfare"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-home"></i>
                </span>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Postnummer *</label>
                  <div class="control">
                    <input
                      name="postal-code"
                      class="input"
                      type="text"
                      v-model="customer.postal_code"
                    />
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">Stad *</label>
                  <div class="control">
                    <input
                      name="address-level2"
                      class="input"
                      type="text"
                      v-model="customer.locality"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="columns" v-if="extendedFields">
              <div class="column">
                <div class="field">
                  <label class="label">Namn förälder 1 *</label>
                  <div class="control has-icons-left">
                    <input
                      name="parent-name-first"
                      class="input"
                      type="text"
                      v-model="customer.parent_name_first"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">Namn förälder 2</label>
                  <div class="control has-icons-left">
                    <input
                      name="parnet-name-second"
                      class="input"
                      type="text"
                      v-model="customer.parent_name_second"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns" v-if="extendedFields">
              <div class="column">
                <div class="field">
                  <label class="label">Telefonnummer förälder 1 *</label>
                  <div class="control has-icons-left">
                    <input
                      name="parent-phone-first"
                      class="input"
                      type="text"
                      v-model="customer.parent_phone_first"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-phone"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">Telefonnummer förälder 2</label>
                  <div class="control has-icons-left">
                    <input
                      name="parnet-phone-second"
                      class="input"
                      type="text"
                      v-model="customer.parent_phone_second"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-phone"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="field">
              <label class="label">Mailadress *</label>
              <div class="control has-icons-left">
                <input
                  name="email"
                  class="input"
                  type="text"
                  v-model="customer.email"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
              </div>
            </div>

            <div class="field" v-if="!extendedFields">
              <label class="label">Telefonnummer *</label>
              <div class="control has-icons-left">
                <input
                  name="tel"
                  class="input"
                  type="text"
                  v-model="customer.phone_number"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-phone"></i>
                </span>
              </div>
            </div>

            <div class="field" v-if="extendedFields">
              <label class="label">Övrigt (Tex allergier eller liknande) </label>
              <div class="control">
                <input
                  name="tel"
                  class="input"
                  type="text"
                  v-model="customer.other"
                />
              </div>
            </div>

            <br />
            <div class="field" v-if="extendedFields">
              <label class="checkbox">
                <input type="checkbox" v-model="canSwim" />
                {{ customer.first_name }} kan simma 200 meter. *
              </label>
            </div>
            <div class="field" v-if="extendedFields">
              <label class="checkbox">
                <input type="checkbox" v-model="customer.member" />
                {{ customer.first_name }} är medlem i {{ nameText }}.
              </label>
            </div>
            <div class="field" v-if="extendedFields">
              <label class="checkbox">
                <input type="checkbox" v-model="customer.photo" />
                {{ customer.first_name }} får förekomma på bilder på
                {{ nameText }}s sociala medier och hemsida (Vänligen lämna
                omarkerad om detta inte är).
              </label>
            </div>
            <div class="field">
              <label class="checkbox">
                <input type="checkbox" v-model="accept" /> Genom att boka
                accepterar jag att {{ nameText }} behandlar samt lagrar mina
                personuppgifter. *
              </label>
            </div>
          </form>
        </section>
        <section class="modal-card-body" v-if="step == 0">
          <div class="columns">
            <div class="column">
              <div class="info-block">
                <b>Kurstyp:</b> <br />
                {{ course.type }}
              </div>

              <div class="info-block">
                <b>Lediga platser:</b> <br />

                <span class="icon is-small is-left icon-info">
                  <i class="fas fa-user"></i>
                </span>

                {{ course.numberOfParticipants - course.numberOfBookings }}/{{
                  course.numberOfParticipants
                }}
              </div>
            </div>

            <div class="column">
              <div class="info-block">
                <b>Datum:</b> <br />

                <span class="icon is-small is-left icon-info">
                  <i class="fas fa-calendar"></i>
                </span>

                {{ course.startDate | formatDateDay }} -
                {{ course.endDate | formatDateDay }}
              </div>

              <div class="info-block">
                <b>Tid:</b> <br />

                <span class="icon is-small is-left icon-info">
                  <i class="fas fa-clock"></i>
                </span>
                {{ course.time }}
              </div>
            </div>
          </div>

          <hr />
          <h1 class="title is-5">Bokning</h1>
          <span v-html="bookText"></span>
        </section>
        <section class="modal-card-body" v-if="step == 2">
          <h3 class="title is-4">Betalningsmetod</h3>
          Vänligen välj betalningsmetod:
          <br />
          <br />
          <div v-for="method in paymentMethods" class="field" :key="method._id">
            <label class="radio">
              <input
                type="radio"
                :id="method.paymentName"
                :value="method.paymentName"
                v-model="paymentMethod"
              />
              {{ method.paymentName }}
            </label>
          </div>
        </section>
        <section class="modal-card-body" v-if="step == 4">
          Tack för din bokning!
        </section>
        <section class="modal-card-body" v-if="step == 3">
          Vänligen betala via swish!
        </section>
        <footer class="modal-card-foot">
          <button
            class="button is-danger"
            @click="back"
            v-if="step != 3 && step != 4"
          >
            Tillbaka
          </button>
          <button
            class="button is-success add"
            @click="step += 1"
            v-if="step == 0"
          >
            Boka denna kurs
          </button>
          <button
            class="button is-success add"
            @click="step += 1"
            v-if="step == 1"
            :disabled="valid()"
          >
            Vidare till betalning
          </button>
          <button class="button is-success add" @click="book" v-if="step == 2">
            Boka
          </button>
        </footer>
      </div>
      <button class="modal-close is-large" aria-label="close"></button>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request.js";

export default {
  name: "BookCourse",
  props: ["course"],
  data: function () {
    return {
      customer: {},
      accept: false,
      step: 0,
      paymentMethod: "",
      loading: false,
      bookText: "",
      nameText: "",
      canSwim: false,
      company_name: process.env.VUE_APP_COMPANY,
      extendedFields: false,
    };
  },
  created: function () {
    this.getPaymentMethods();
    this.getBookText();
    this.getNameText();
    this.getExtendedFields();

    this.customer.member = false;
    this.customer.photo = false;

  },
  methods: {
    valid: function () {
      if (this.extendedFields) {
        return !(
          !!this.customer.first_name &&
          !!this.customer.last_name &&
          !!this.customer.thoroughfare &&
          !!this.customer.postal_code &&
          !!this.customer.locality &&
          !!this.customer.email &&
          !!this.customer.parent_name_first &&
          !!this.customer.parent_phone_first &&
          !!this.customer.ssi &&
          !!this.canSwim &&
          !!this.accept
        );
      } else {
        return !(
          !!this.customer.first_name &&
          !!this.customer.last_name &&
          !!this.customer.thoroughfare &&
          !!this.customer.postal_code &&
          !!this.customer.locality &&
          !!this.customer.email &&
          !!this.customer.phone_number &&
          !!this.accept
        );
      }
    },
    getPaymentMethods: function () {
      axios.get("/api/payment_methods").then((res) => {
        this.paymentMethods = res.data.filter(
          (paymentMethod) => paymentMethod.enabled
        );
        this.paymentMethod = this.paymentMethods[0]["paymentName"];
      });
    },
    getBookText: function () {
      axios.get("/api/texts/book").then((response) => {
        this.bookText = response.data;
      });
    },
    getNameText: function () {
      axios.get("/api/texts/name").then((response) => {
        this.nameText = response.data;
      });
    },
    getExtendedFields: function () {
      axios.get("/api/settings/extendedfields").then((response) => {
        this.extendedFields = response.data;
      });
    },
    back: function () {
      if (this.step == 0) {
        this.closeBooking();
      } else {
        this.step += -1;
      }
    },
    closeBooking() {
      if (this.step != 3) {
        this.step = 0;
        this.$emit("closeBooking");
      }
    },
    fetchSwishStatus(course_id) {
      axios.get(`/api/swish/status/${course_id}`).then((res) => {
        if (res.data.status == "PAID") {
          this.step = 4;
        } else {
          setTimeout(this.fetchSwishStatus, 5000, course_id);
        }
      });
    },
    book() {
      axios.post("/api/customers", this.customer).then((response) => {
        axios
          .post("/api/bookings", {
            course_id: this.course._id,
            customer_id: response.data._id,
            payment_method: this.paymentMethod,
          })
          .then((response) => {
            if (this.paymentMethod == "Swish") {
              this.step = 3;
              this.fetchSwishStatus(response.data._id);
            } else {
              this.step = 4;
            }
          });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add {
  margin-left: auto;
}

.info-block {
  padding: 5px;
  align-content: center;
}

.modal-card-title {
  font-size: 14;
  display: block;
}


</style>